import { InsuranceInfoData } from '@shared/sec-loans'
import { OptionalAndNullable } from '@shared/typeHelpers'
import { convertUndefinedToNull } from '@ui-common/utils/form'
import { getYesNoDefault } from '@ui-common/utils/helpers'

import { StepDataValidator } from '../../../types'
import { isFormDataValid } from '../../../wizardData'
import { createFormValidator } from './formValidator'
import { InsuranceInfoFormData } from './types'

export const convertToFormValues = (
  insuranceInfoData: InsuranceInfoData | undefined,
): OptionalAndNullable<InsuranceInfoFormData> => {
  return convertUndefinedToNull({
    isInterestedInInsurance: getYesNoDefault(!!insuranceInfoData, insuranceInfoData?.isInterestedInInsurance),
  })
}

export const getAndValidateInsuranceInfoTypeData: StepDataValidator<InsuranceInfoData | undefined> = ({
  validationData,
}) => {
  const insuranceInfoData = validationData.loanInfo?.insuranceInfoData
  return isFormDataValid(convertToFormValues(insuranceInfoData), createFormValidator) ? insuranceInfoData : undefined
}
